import { useEffect } from "react";

import { CycleCountDetailsViewModel } from "../../viewmodels/cycleCounts/CycleCountDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import CycleCountDetailsForm from "../../components/forms/cycleCounts/CycleCountDetailsForm";
import EmptyModal from "../../components/modals/EmptyModal";
import TableLoadingSkeleton from "../../components/shared/TableLoadingSkeleton";
import { useNavigate, useParams } from "react-router-dom";

function CycleCountDetails(props) {
  const { addSnackbar, logout } = props;

  const { cycleCountId } = useParams();

  const navigate = useNavigate();

  const {
    emptyModal,
    setEmptyModelOpen,
    loading,
    cycleCount,
    getCycleCountDetails,
    updateCycleCountStatus,
    printCycleCountSummary,
    printCycleCountDetails,
    printMissingItems,
    askDeleteCycleCount,
    navigateUserAfterDeletion,
    askRelocateItem,
    selectedRelocationItems,
    setSelectedRelocationItems,
    relocateInProgress,
    askRelocateMultipleItems,
    selectedMissingItems,
    setSelectedMissingItems,
    askMarkItemMissing,
    askDeleteShippedItemsFromCC,
    askUnlockLockedItems,
    selectedShippingItems,
    setSelectedShippingItems,
    selectedLockedItems,
    setSelectedLockedItems,
    getCorrectItemsGroupedByPlu,
    getWrongItemsGroupedByPlu,
    getMissingItemsGroupedByPlu,
    getShippedItemsGroupedByPlu,
    getLockedItemsGroupedByPlu,
  } = CycleCountDetailsViewModel(logout, cycleCountId, addSnackbar);

  useEffect(() => {
    getCycleCountDetails();
  }, []);

  useEffect(() => {
    if (navigateUserAfterDeletion) {
      navigate("/cycle-counts");
    }
  }, [navigateUserAfterDeletion]);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        {loading ? (
          <TableLoadingSkeleton rows={5} columns={4} />
        ) : (
          <CycleCountDetailsForm
            cycleCount={cycleCount}
            printCycleCountDetails={printCycleCountDetails}
            printCycleCountSummary={printCycleCountSummary}
            printMissingItems={printMissingItems}
            updateCycleCountStatus={updateCycleCountStatus}
            askDeleteCycleCount={askDeleteCycleCount}
            askRelocateItem={askRelocateItem}
            selectedRelocationItems={selectedRelocationItems}
            setSelectedRelocationItems={setSelectedRelocationItems}
            relocateInProgress={relocateInProgress}
            askRelocateMultipleItems={askRelocateMultipleItems}
            selectedMissingItems={selectedMissingItems}
            setSelectedMissingItems={setSelectedMissingItems}
            askMarkItemMissing={askMarkItemMissing}
            selectedShippingItems={selectedShippingItems}
            setSelectedShippingItems={setSelectedShippingItems}
            selectedLockedItems={selectedLockedItems}
            setSelectedLockedItems={setSelectedLockedItems}
            askDeleteShippedItemsFromCC={askDeleteShippedItemsFromCC}
            askUnlockLockedItems={askUnlockLockedItems}
            getCorrectItemsGroupedByPlu={getCorrectItemsGroupedByPlu}
            getWrongItemsGroupedByPlu={getWrongItemsGroupedByPlu}
            getMissingItemsGroupedByPlu={getMissingItemsGroupedByPlu}
            getShippedItemsGroupedByPlu={getShippedItemsGroupedByPlu}
            getLockedItemsGroupedByPlu={getLockedItemsGroupedByPlu}
          />
        )}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
        size={emptyModal.size}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CycleCountDetails)
);
